<template>
  <!-- Same guest/auth route keying as ConsoleApp (see its comment). -->
  <router-view :key="route.meta.isGuest ? 'guest' : 'auth'" />
  <Toaster position="bottom-right" :rich-colors="true" :close-button="true" />
</template>

<script setup lang="ts">
import { watch, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Toaster } from 'vue-sonner'
import { useAuthStore } from '@/stores/auth'

// The admin panel's root — deliberately LEAN next to ConsoleApp: no
// ActionCable, no push registration, no import toasts, no org store. The one
// piece of shell logic it shares is the two-phase logout (redirect first,
// clearProfile only after the protected subtree unmounted).
const router = useRouter()
const route = useRoute()
const auth = useAuthStore()

watch(() => auth.isAuthenticated, async (isAuth) => {
  if (!isAuth && !route.meta.isGuest) {
    await router.replace('/login')
    await nextTick()
    auth.clearProfile()
  }
})
</script>
